module.exports = __webpack_public_path__ + "img/chevron-compact-down.9ce3d469.svg";